import { render, staticRenderFns } from "./CabinClassSelectorDropdown.vue?vue&type=template&id=fa15f768&scoped=true&"
import script from "./CabinClassSelectorDropdown.vue?vue&type=script&lang=js&"
export * from "./CabinClassSelectorDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa15f768",
  null
  
)

export default component.exports